<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="dedication" role="doc-dedication">
<p class="DED-TOP" id="ded"><span aria-label="v" id="pg_v" role="doc-pagebreak"><b><i>This book is dedicated</i></b></span></p>
<p class="DED">to those who loved <i>Abandoned Breaths</i></p>
<p class="DED">enough to let the words breathe,</p>
<p class="DED">and to everyone who fights the stigma</p>
<p class="DED">of heartache. You are not weak</p>
<p class="DED">because you feel.</p>
<p class="HALF-SPACE1"> </p>
<p class="DED">You are the strongest souls I know.</p>
<p class="HALF-SPACE1"> </p>
<p class="DED">Everyone becomes a poet when their</p>
<p class="DED">hearts are screaming.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?62840f6c